import LessonBehaviorSettings, {
  LessonCompletionType
} from '../models/LessonBehaviorSettings';

import { ApiLessonAsset } from '../models/ApiLessonAsset';
import CourseVersionMap from '../../content/models/CourseVersionMap';
import { LessonCompletionFlags } from '../models/LessonNativeSettings';
import LessonDisplaySettings from '../models/LessonDisplaySettings';
import LessonVersionAsset from '../models/LessonVersionAsset';
import { ModuleBehaviourEnum } from '../models/ApiLesson';

class SettingsService {
  public convertLessonAssetToDisplaySettings(
    asset: ApiLessonAsset
  ): LessonDisplaySettings {
    return {
      background: asset?.background
        ? {
            type: asset.background.colour ? 'color' : 'image',
            value: asset.background.colour || asset.background.image,
            containerColor: asset.background.containerColor
          }
        : null,
      icon: asset?.icon
        ? {
            type: asset.icon.colour ? 'color' : 'image',
            value: asset.icon.colour || asset.icon.image
          }
        : null,
      palette: asset?.palette
    };
  }

  public convertBehaviorSettings(
    flags: number,
    lessonVersionAsset: LessonVersionAsset,
    courseVersionMap: CourseVersionMap
  ): LessonBehaviorSettings {
    return {
      showAllVersions: this.isFlagSet(
        flags,
        ModuleBehaviourEnum.ShowAllVersions
      ),
      //* Uncomment the following when lockCompletedLessons is added.
      // lockCompletedLessons: isFlagSet(
      //   flags,
      //   ModuleBehaviourEnum.LockCompletedVersions
      // ),
      lockCourse: courseVersionMap?.required,
      editAllVersions: this.isFlagSet(
        flags,
        ModuleBehaviourEnum.EditAllVersions
      ),
      // Multiple Attempts moved from lesson to lesson version
      multipleAttempts: !lessonVersionAsset?.native?.singleAttemptPerVersion,
      completionType: this.convertCompletionType(
        lessonVersionAsset?.native?.completionFlags
      ),
      completionThreshold: lessonVersionAsset?.native?.threshold || 100,
      remindReattempt: false
    };
  }

  public convertCompletionType(flags: number): LessonCompletionType {
    return this.isFlagSet(flags, LessonCompletionFlags.CompleteAtThreshold)
      ? 'threshold'
      : 'atEnd';
  }

  public isFlagSet(flags: number, flag: number): boolean {
    return (flags & flag) === flag;
  }
}

export default new SettingsService();
